var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attr-category"},[_c('CompButton',{attrs:{"placeholder":"选择标签","format":"{0}个标签","value":_vm.value.length,"view-btn":false},on:{"click":_vm.onAddLabel,"remove":_vm.onRemoveLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }